import { TvsLieferantRechnungApiDto, TvsLieferantRechnungDetailApiDto } from '@/api-schema';
import { RechnungFilterDto } from '@/types/RechnungFilterDto';

export interface IPraxisgruppeRechnungenState {
    rechnungList: Array<TvsLieferantRechnungApiDto>;
    rechnungenDetails: Array<TvsLieferantRechnungDetailApiDto>;
    queryFilter: RechnungFilterDto;
    loading: boolean;
    totalNumberOfRecords: number | null;
    tvsKundeTeilnehmerIdsForFilter: Array<object>;
}

export const state: IPraxisgruppeRechnungenState = {
    loading: false,
    totalNumberOfRecords: null,
    rechnungList: [],
    rechnungenDetails: [],
    queryFilter: new RechnungFilterDto(),
    tvsKundeTeilnehmerIdsForFilter: []
};
